<template>
<div>

	<!-- Begin Title Bar -->
	<v-toolbar tile elevation="2">
		<v-toolbar-title>{{ $t('nav.marketplace') }}</v-toolbar-title>

		<v-spacer></v-spacer>

		<v-btn icon v-if="initializationDone" @click="$router.go(-1)">
			<v-icon class="color-green">mdi-arrow-left</v-icon>
		</v-btn>
		<v-btn icon v-if="initializationDone" @click="refresh">
			<v-icon class="color-green">mdi-refresh</v-icon>
		</v-btn>
		<v-btn icon v-if="initializationDone" @click="showHelp = true">
			<v-icon class="color-green">mdi-help-circle</v-icon>
		</v-btn>
	</v-toolbar>
	<!-- End Title Bar -->

	<v-container>
	<Preloader v-show="!initializationDone" :text="$t('common.phrase.loading')" />


	<v-sheet v-if="initializationDone" elevation="2" class="py-0 mb-4">

		<v-container>

			<v-row dense>

				<v-col class="text-center px-2 py-1">
					<!-- Begin popular trading pairs dropdown -->
					<PopularTradingPairList></PopularTradingPairList>
				</v-col>

				<v-col class="text-center px-2 py-1">
					<!-- Begin token pair watch list dropdown -->
					<TrackedTradingPairList
						show-add-new-token-pair-option
						v-on:tracked-token-pair-show-add-new="showAddNewTokenPairWatchForm = true"
					>
					</TrackedTradingPairList>
				</v-col>

			</v-row>

		</v-container>

	</v-sheet>

	<!-- begin new token pair watch form -->
  <div v-if="initializationDone" class="mb-4"
    id="add-new-token-pair-watch-section" v-show="showAddNewTokenPairWatchForm">

      <AddTokenPairWatchForm v-if="showAddNewTokenPairWatchForm"
        v-on:add-token-pair-watch-list-form-close="handleAddTokenPairWatchListClose()">
      </AddTokenPairWatchForm>

  </div>
  <!-- end new token pair watch form -->

	<v-sheet v-if="initializationDone" elevation="2" class="px-2 my-4">

		<v-container>

			<v-row dense class="mt-1">
				<v-col cols="12" sm="4" class="nowrap">

					<ERC20Token :symbol="makerAssetInfo.symbol"
						:name="makerAssetInfo.name"
						:address="makerAssetInfo.address"
						:decimals="makerAssetInfo.decimals"
						:tokenurl="tokenurl" large >
					</ERC20Token>

					<v-icon large color="grey">mdi-swap-horizontal</v-icon>

					<ERC20Token :symbol="takerAssetInfo.symbol"
						:name="takerAssetInfo.name"
						:address="takerAssetInfo.address"
						:decimals="takerAssetInfo.decimals"
						:tokenurl="tokenurl" large >
					</ERC20Token>

					<v-btn v-if="isMobile" icon class="float-right"
						@click="loadAllRelayerOrdersShowingDummyLoading"
						:disabled="dummyLoading" :loading="dummyLoading"
					>
						<v-icon class="color-green">mdi-refresh</v-icon>
					</v-btn>

				</v-col>

				<v-col cols="6" sm="3">

					<!-- Begin token pair watching -->
					<div class="text-center">
						<v-menu offset-y dense>
							<template v-slot:activator="{ on }">
								<v-btn block tile outlined v-on="on">
									<span v-if="tokenTrackingRequestLoding">
										<span v-if="isTokenPairWatched">
											{{ $t('common.verb.removing')}}...
											<ButtonLoading size="18" color="grey" class="ml-3" />
										</span>
	                  <span v-else>
	                  	{{ $t('common.verb.adding')}}...
	                  	<ButtonLoading size="18" color="grey" class="ml-3" />
	                  </span>
	                </span>
	                <span v-else-if="isTokenPairWatched">
		                {{ $t('compOrdersByTokenPair.watched') }}
		                <v-icon>mdi-chevron-down</v-icon>
		              </span>
	                <span v-else>
	                	{{ $t('compOrdersByTokenPair.notWatched') }}
	                	<v-icon>mdi-chevron-down</v-icon>
	                </span>
								</v-btn>
							</template>
							<v-list dense class="overflow-y-auto" max-height="300">
								<v-list-item v-if="isTokenPairWatched" @click="deleteTokenPairTracking">
									<v-list-item-title>
										<v-icon>mdi-minus-circle</v-icon> {{ $t('compOrdersByTokenPair.removeFromWatchlist') }}
									</v-list-item-title>
								</v-list-item>
								<v-list-item v-else @click="addTokenPairTracking">
									<v-list-item-title>
										<v-icon>mdi-plus-circle</v-icon> {{ $t('compOrdersByTokenPair.addToWatchlist') }}
									</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</div>

				</v-col>

				<v-col cols="6" sm="3">

					<!-- Begin new order dropdown -->
					<div class="text-center">
						<v-menu offset-y dense>
							<template v-slot:activator="{ on }">
								<v-btn block tile outlined v-on="on">
									{{ $t('compOrdersByTokenPair.createOrder') }}
									<v-icon>mdi-chevron-down</v-icon>
								</v-btn>
							</template>
							<v-list dense class="overflow-y-auto" max-height="300">
								<v-list-item @click="showNewOrderModal('maker-taker')">
									<v-list-item-title>
										{{ $t('common.verb.sell') }} {{ makerAssetInfo.symbol }}, {{ $t('common.verb.buy') }} {{ takerAssetInfo.symbol }}
									</v-list-item-title>
								</v-list-item>
								<v-list-item @click="showNewOrderModal('taker-maker')">
									<v-list-item-title>
										{{ $t('common.verb.sell') }} {{ takerAssetInfo.symbol }}, {{ $t('common.verb.buy') }} {{ makerAssetInfo.symbol }}
									</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</div>

				</v-col>

				<v-col v-if="!isMobile" cols="2" sm="2">
					<v-btn icon class="float-right"
						@click="loadAllRelayerOrdersShowingDummyLoading"
						:disabled="dummyLoading" :loading="dummyLoading"
					>
						<v-icon class="color-green">mdi-refresh</v-icon>
					</v-btn>
				</v-col>

			</v-row>

			<v-simple-table dense class="mt-3">
				<template v-slot:default>

				<tr v-show="filteredAskList.length > 0 || filteredBidList.length > 0" class="price-table-header">
					<td v-if="!isMobile" class="text-right">{{ makerAssetInfo.symbol }} {{ $t('common.noun.amount') }}</td>
					<td v-if="!isMobile" class="text-right">{{ takerAssetInfo.symbol }} {{ $t('common.noun.amount') }}</td>
					<td class="text-right">1 {{ makerAssetInfo.symbol }} = ? {{ takerAssetInfo.symbol }}</td>
					<td class="text-right">1 {{ takerAssetInfo.symbol }} = ? {{ makerAssetInfo.symbol }}</td>
					<td></td>
				</tr>

				<SimpleOrderSummary v-for="order of filteredAskList.slice().reverse()"
				 :key="order.orderHash + getCurrentUnixTime()"
				 :showavailablemakeramount="!isMobile"
				 :showavailabletakeramount="!isMobile"
				 showpricetakerpermaker showpricemakerpertaker
				 initialorderstatechecking
				 :continuousorderstatechecking="liveDataOn"
				 :relayer="order.relayer"
				 :parsedOrder="order"
				 :accounturl="networkConfig.accountURL"
				 :tokenurl="networkConfig.tokenURL"
				 :myaddress="myAddress" :myaccount="account"
				 v-on:simple-order-summary-order-not-fillable="handleAskOrderNoLongerFillable($event)"
				 v-on:simple-order-summary-show-fill-order="showFillOrderModal($event)"
				 >
				</SimpleOrderSummary>

				<tr v-show="filteredAskList.length == 0">
					<td :colspan="isMobile ? 3 : 5" class="empty-order-cell">
						{{ $t('compOrdersByTokenPair.noAskOrder') }}
						<v-btn color="primary" class="ml-3" @click="showNewOrderModal('maker-taker')">
							{{ $t('compOrdersByTokenPair.createOrder') }}
						</v-btn>
					</td>
				</tr>

				<tr class="price-table-spread">
					<td v-if="!isMobile" class="text-right"></td>
					<td v-if="!isMobile"></td>
					<td class="text-right order-table-number"><AmountNumber :value="spreadReverse" digits="7" keepzeros /></td>
					<td class="text-right order-table-number"><AmountNumber :value="spread" digits="7" keepzeros /></td>
					<td class="text-right">{{ $t('compOrdersByTokenPair.spread') }}</td>
				</tr>

				<SimpleOrderSummary v-for="order of filteredBidList"
				 :key="order.orderHash + getCurrentUnixTime()"
				 reversedisplay
				 :showavailablemakeramount="!isMobile"
				 :showavailabletakeramount="!isMobile"
				 showpricetakerpermaker showpricemakerpertaker
				 initialorderstatechecking
				 :continuousorderstatechecking="liveDataOn"
				 :relayer="order.relayer"
				 :parsedOrder="order"
				 :accounturl="networkConfig.accountURL"
				 :tokenurl="networkConfig.tokenURL"
				 :myaddress="myAddress" :myaccount="account"
				 v-on:simple-order-summary-order-not-fillable="handleBidOrderNoLongerFillable($event)"
				 v-on:simple-order-summary-show-fill-order="showFillOrderModal($event)"
				 >
				</SimpleOrderSummary>

				<tr v-show="filteredBidList.length == 0">
					<td :colspan="isMobile ? 3 : 5" class="empty-order-cell">
						{{ $t('compOrdersByTokenPair.noBidOrder') }}
						<v-btn color="primary" class="ml-3" @click="showNewOrderModal('taker-maker')">
							{{ $t('compOrdersByTokenPair.createOrder') }}
						</v-btn>
					</td>
				</tr>

				</template>
			</v-simple-table>

		</v-container>

	</v-sheet>

	<!-- Begin Help -->
	<v-bottom-sheet v-model="showHelp">

		<v-card tile>

			<!--Modal Title -->
			<v-toolbar flat v-bind:class="{'green lighten-3': !$vuetify.theme.dark, 'grey darken-2': $vuetify.theme.dark }">
				<v-toolbar-title><v-icon>mdi-help-circle</v-icon> {{ $t('nav.help') }}</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon @click="showHelp = false">
					<v-icon>mdi-window-close</v-icon>
				</v-btn>
			</v-toolbar>

			<!-- Modal Contents -->
			<v-card-text class="py-5 px-3" style="max-height: 400px; overflow-y: scroll;">
				<MarketplaceHelp class="mb-2"></MarketplaceHelp>
			</v-card-text>

		</v-card>

  </v-bottom-sheet>
  <!-- End Help -->

	<FillOrderModal v-if="initializationDone"
		ref="fillOrderModal" key="OrderByTokenPair-FillOrderModal" :fullscreen="isMobile"
	/>

	<NewOrderModal ref="newOrderModal"
		key="OrderByTokenPair-NewOrderModal"
		v-on:new-order-modal-success="refresh()" :fullscreen="isMobile"
	/>

</v-container>
</div>
</template>

<script>

import { config } from '@/config'
import { Web3Wrapper } from '@0x/web3-wrapper'
import {mapActions, mapGetters, mapState} from 'vuex'
import Preloader from "@/components/Preloader"
import AmountNumber from "@/components/AmountNumber"
import ERC20Token from "@/components/ERC20Token"
import { HttpClient } from '@0x/connect'
import BackButton from "@/components/BackButton"
import { sortOrderByPriceAsc, sortOrderByPriceDes, formatAmountNumber, getCurrentUnixTime, sleep, getCurrentGasPrice } from '@/utils/utils'
import { assetDataUtils } from '@0x/order-utils'
import SimpleOrderSummary from "@/components/SimpleOrderSummary"
import FillOrderModal from "@/components/FillOrderModal"
import AddTokenPairWatchForm from "@/components/AddTokenPairWatchForm"
import ButtonLoading from "@/components/ButtonLoading"
import NewOrderModal from "@/components/NewOrderModal"
import PopularTradingPairList from "@/components/PopularTradingPairList"
import TrackedTradingPairList from "@/components/TrackedTradingPairList"
import MarketplaceHelp from "@/components/help/MarketplaceHelp"


export default {
	name: 'OrdersByTokenPair',
	components: {
		FillOrderModal,
		SimpleOrderSummary,
		NewOrderModal,
		Preloader,
		BackButton,
		AmountNumber,
		ERC20Token,
		MarketplaceHelp,
		AddTokenPairWatchForm,
		ButtonLoading,
		PopularTradingPairList,
		TrackedTradingPairList
	},
	data () {
		return {
			config: config,
			makerAssetInfo: null,
			takerAssetInfo: null,
			askList: [],
			askListByRelayer: {},
			bidList: [],
			bidListByRelayer: {},
			invalidAskOrderTracking: {},
			invalidBidOrderTracking: {},
			numDisplayAsks: 0,
			numDisplayBids: 0,
			initializationDone: false,
			showHelp: false,
			allRelayerOrdersLoading: false,
			tokenTrackingRequestLoding: false,
			loopJob: null,
			// tokenPairOptions: [],
			// selectedTokenPair: null,
			dummyLoading: false,
			showAddNewTokenPairWatchForm: false,
		}
	},
	computed: {
		...mapGetters({
			network: 'getNetwork',
			account: 'getAccount',
			myAddress: 'getUserAccount',
			tokenInfo: 'getTokenInfo',
			relayerList: 'getRelayerList',
			relayerInfo: 'getRelayerInfo',
			supportedERC20AssetPairsByRelayer: 'getSupportedERC20AssetPairsByRelayer',
			networkConfig: 'getNetworkConfig',
		}),
		isMobile: function () {
      return this.$vuetify.breakpoint.xsOnly
    },
		makerAssetSymbol: function () {
			return this.$route.params.makerAssetSymbol || this.tokenInfo.ZRXToken.symbol
		},
		takerAssetSymbol: function () {
			return this.$route.params.takerAssetSymbol || this.tokenInfo.WETHToken.symbol
		},
		makerAssetAddress: function () {
			return this.$route.params.makerAssetAddress || this.tokenInfo.ZRXToken.address
		},
		takerAssetAddress: function () {
			return this.$route.params.takerAssetAddress || this.tokenInfo.WETHToken.address
		},
		tokenurl: function () {
			return this.networkConfig.tokenURL
		},
		liveDataOn: function () {
			return this.loopJob ? true : false
		},
		filteredAskList: function () {
      const numOrders = this.config.numOpenOrdersToShowForBidsAndAsks
      if (!this.askList || this.askList.length === 0) {
        return []
      }
      const list = [...this.askList]
      list.sort(sortOrderByPriceDes)
      const filteredList = list.slice(0, numOrders)
      return filteredList
    },
    filteredBidList: function () {
      const numOrders = this.config.numOpenOrdersToShowForBidsAndAsks
      if (!this.bidList || this.bidList.length === 0) {
        return []
      }
      const list = [...this.bidList]
      list.sort(sortOrderByPriceDes)
      const filteredList = list.slice(0, numOrders)
      return filteredList
    },
		spread: function () {
			if (this.filteredAskList.length > 0 && this.filteredBidList.length > 0) {
				const order1 = this.filteredAskList[0]
				const order2 = this.filteredBidList[0]
				const price1 = order1.priceMakerPerTaker
				const price2 = order2.priceTakerPerMaker
				return price2 - price1
			}
			else {
				return 0
			}
		},
		spreadReverse: function () {
			if (this.filteredAskList.length > 0 && this.filteredBidList.length > 0) {
				const order1 = this.filteredAskList[0]
				const order2 = this.filteredBidList[0]
				const price1 = order1.priceTakerPerMaker
				const price2 = order2.priceMakerPerTaker
				return price1 - price2
			}
			else {
				return 0
			}
		},
		supportedRelayerList: function () {
			if (this.relayerList) {
				const list = []
				for (let relayer of this.relayerList) {
					if (this.supportedByRelayer(relayer.name)) {
						list.push(relayer)
					}
				}
				list.sort(function(a, b) {return b.orderBookPriority - a.orderBookPriority})
				return list
			}
			else {
				return null
			}
		},
		hasOrders: function () {
			return this.filteredAskList.length > 0 || this.filteredBidList.length > 0
		},
		showLiveDataOption: function () {
			return (this.supportedRelayerList && this.supportedRelayerList.length > 1)
		},
		isTokenPairWatched: function () {
			if (this.account.trackedTokenPairs) {
				for (let pair of this.account.trackedTokenPairs) {
					if (pair.tokenA.address === this.makerAssetAddress &&
						pair.tokenB.address === this.takerAssetAddress) {
						return true
					}
				}
				return false
			}
			else {
				return false
			}
		}
	},
	methods: {
		...mapActions(['loadNetwork', 'loadTokenInfo', 'loadAccount', 'getTokenInfoByAddress', 'loadRelayerInfo', 'parseSignedOrder']),

		/* ------------------------------------------------------ */
		async init () {
			// console.log('tokenType', this.tokenType)
			this.initializationDone = false
			this.allRelayerOrdersLoading = false
			try {
				await this.loadNetwork()
				await this.loadTokenInfo()
				await this.loadAccount()
				await this.loadRelayerInfo()
				await getCurrentGasPrice(this.network.id)
				// console.log(this.relayerInfo)
			} catch (err) {
				console.log(err)
				this.$emit("errorNotification", this.$t('common.err.generic'))
			}

			this.askList = []
			this.bidList = []
			this.askListByRelayer = {}
			this.bidListByRelayer = {}
			this.numDisplayAsks = 0
			this.numDisplayBids = 0
			this.invalidAskOrderTracking = {}
			this.invalidBidOrderTracking = {}
			// this.tokenPairOptions = []
			this.tokenTrackingRequestLoding = false
			// this.selectedTokenPair = null
			for (let relayer of this.supportedRelayerList) {
				this.askListByRelayer[relayer.name] = []
				this.bidListByRelayer[relayer.name] = []
			}

			this.makerAssetInfo = await this.getTokenInfoByAddress(this.makerAssetAddress)
			// console.log('makerAssetInfo:', this.makerAssetInfo)
			this.takerAssetInfo = await this.getTokenInfoByAddress(this.takerAssetAddress)
			// console.log('takerAssetInfo:', this.takerAssetInfo)

			await this.loadAllRelayerOrders()

			if (this.config.tokenPairOrderCheckingLiveDataByDefault) {
				this.loopJob = setInterval(this.loadAllRelayerOrders, this.config.tokenPairOrderCheckingInterval)
			}
			this.initializationDone = true
		},

		sortOrderByPriceAsc: sortOrderByPriceAsc,
		sortOrderByPriceDes: sortOrderByPriceDes,
		formatAmountNumber: formatAmountNumber,
		getCurrentUnixTime: getCurrentUnixTime,

		turnOnLiveData () {
			if (this.loopJob) {
				return
			}
			this.loopJob = setInterval(this.loadAllRelayerOrders, this.config.tokenPairOrderCheckingInterval)
		},

		turnOffLiveData () {
			if (this.loopJob) {
				clearInterval(this.loopJob)
				this.loopJob = null
			}
		},

		async refresh () {
			this.init();
		},

		buildOrderList: function () {

			const askList = []
			const askTracking = {}
			if (this.supportedRelayerList && this.supportedRelayerList.length > 0) {
				for (let relayer of this.supportedRelayerList) {
					const relayerOrderList = this.askListByRelayer[relayer.name]
					// console.log(relayerOrderList)
					for (let order of relayerOrderList) {
						if (!askTracking[order.orderHash]) {
							askList.push(order)
							askTracking[order.orderHash] = true
						}
					}
				}
			}
			this.askList = askList
			this.numDisplayAsks = this.filteredAskList.length

			const bidList = []
			const bidTracking = {}
			if (this.supportedRelayerList && this.supportedRelayerList.length > 0) {
				for (let relayer of this.supportedRelayerList) {
					const relayerOrderList = this.bidListByRelayer[relayer.name]
					// console.log(relayerOrderList)
					for (let order of relayerOrderList) {
						if (!bidTracking[order.orderHash]) {
							bidList.push(order)
							bidTracking[order.orderHash] = true
						}
					}
				}
			}
			this.bidList = bidList
			this.numDisplayBids = this.filteredBidList.length

		},

		supportedByRelayer (relayerName) {
			// console.log('checking support from ' + relayerName)
			if (!this.makerAssetAddress || !this.takerAssetAddress) {
				return
			}
			if (relayerName === 'LedgerDex') {
				return true
			}
			const key = assetDataUtils.encodeERC20AssetData(this.makerAssetAddress.toLowerCase()) + '-' +
									assetDataUtils.encodeERC20AssetData(this.takerAssetAddress.toLowerCase())
			// console.log(key)
			const supported = this.supportedERC20AssetPairsByRelayer(relayerName)
			// console.log(supported)
			if (supported && supported[key]) {
				// console.log('yes')
				return true
			}
			else {
				// console.log('no')
				return false
			}
		},

		async getParsedOrder (record) {

			const order = record.order

			try {
        const orderInfo = await this.parseSignedOrder(order)
        return orderInfo
      } catch (err) {
        console.log(err)
      }

		},

		async loadAllRelayerOrders() {
			// console.log(this.supportedRelayerList)
			if (this.allRelayerOrdersLoading) {
				return
			}
			this.allRelayerOrdersLoading = true
 			// console.log('+++++++++ loading orders ++++++++++')
			const tasks = []
			for (let relayer of this.supportedRelayerList) {
				// await this.loadRelayerOrders(relayer)
				tasks.push(this.loadRelayerOrders(relayer))
			}
			await Promise.all(tasks)
			this.buildOrderList()
			this.allRelayerOrdersLoading = false
		},

		async loadAllRelayerOrdersShowingDummyLoading() {
			if (this.dummyLoading) {
				return
			}
			this.dummyLoading = true
			await sleep(1000)
			await this.loadAllRelayerOrders()
			this.dummyLoading = false
		},

		async loadRelayerOrders(relayer) {

			// console.log('loading orders from ' + relayer.name)

			const relayerApiURL = relayer.apiURL
			const httpClient = new HttpClient(relayerApiURL)

			const searchOptions = {
				baseAssetData: assetDataUtils.encodeERC20AssetData(this.makerAssetAddress),
				quoteAssetData: assetDataUtils.encodeERC20AssetData(this.takerAssetAddress),
				perPage: config.numOrdersToFetchFromRelayers,
			}

			this.askListByRelayer[relayer.name] = []
			this.bidListByRelayer[relayer.name] = []

			let orderBook = null

			try {
				orderBook = await httpClient.getOrderbookAsync(
					searchOptions
				)
				// console.log(orderBook)
				console.log(relayer.name.charAt(0) + ': ' + orderBook.asks.total + ' asks, ' + orderBook.bids.total + ' bids' )
			} catch (err) {
				console.log(relayer.name + ' Error: ' + err)
				return
				// console.log(relayer.name + ' Error: ' + err.toString())
			}

			if (!orderBook || !orderBook.asks || !orderBook.bids) {
				return
			}

			if (orderBook.asks.records) {
				for (let record of orderBook.asks.records) {
					const parsedOrder = await this.getParsedOrder(record)
					// console.log(parsedOrder)
					if (!parsedOrder) {
						continue
					}
					if (this.isExpiringOrder(parsedOrder) || this.isTakerAmountTooLow(parsedOrder)) {
						this.invalidAskOrderTracking[parsedOrder.orderHash] = true
						continue
					}
					parsedOrder.relayer = relayer
					if (!this.invalidAskOrderTracking[parsedOrder.orderHash]) {
						this.askListByRelayer[relayer.name].push(parsedOrder)
					}
				}
			}

			if (orderBook.bids.records) {
				for (let record of orderBook.bids.records) {
					const parsedOrder = await this.getParsedOrder(record)
					if (!parsedOrder) {
						continue
					}
					if (this.isExpiringOrder(parsedOrder) || this.isTakerAmountTooLow(parsedOrder)) {
						this.invalidBidOrderTracking[parsedOrder.orderHash] = true
						continue
					}
					parsedOrder.relayer = relayer
					if (!this.invalidBidOrderTracking[parsedOrder.orderHash]) {
						this.bidListByRelayer[relayer.name].push(parsedOrder)
					}
				}
			}

		},

		isExpiringOrder (parsedOrder) {

			const timeNow = getCurrentUnixTime()
			const expirationTime = parsedOrder.expirationTimeSeconds
			const timeDiff = expirationTime - timeNow
			if (timeDiff <= 5) {
				return true
			}
			else {
				return false
			}

		},

		isTakerAmountTooLow (parsedOrder) {
			if (parsedOrder.takerAssetAmount && parsedOrder.takerAssetAmount < config.minOrderAvailableAmount) {
				console.log('takerAssetAmount too low: ' + parsedOrder.takerAssetAmount)
				return true
			}
			else {
				return false
			}
		},

		handleAskOrderNoLongerFillable (orderHash) {
			console.log('Ask NO LONGER FILLABLE')
			this.invalidAskOrderTracking[orderHash] = true
			const newOrderList = []
			for (let order of this.askList) {
				if (order.orderHash && order.orderHash != orderHash) {
					newOrderList.push(order)
				}
			}
			this.askList = newOrderList
			// When valid orders drop to the halp of the original ones, reload
			if (this.filteredAskList.length < this.numDisplayAsks / 2) {
				console.log('Too few Ask orders. Will reload orders')
				this.loadAllRelayerOrders()
			}
		},

		handleBidOrderNoLongerFillable (orderHash) {
			console.log('Bid NO LONGER FILLABLE')
			this.invalidBidOrderTracking[orderHash] = true
			const newOrderList = []
			for (let order of this.bidList) {
				if (order.orderHash && order.orderHash != orderHash) {
					newOrderList.push(order)
				}
			}
			this.bidList = newOrderList
			// When valid orders drop to the halp of the original ones, reload
			if (this.filteredBidList.length < this.numDisplayBids / 2) {
				console.log('Too few Bid orders. Will reload orders')
				this.loadAllRelayerOrders()
			}
		},

		async addTokenPairTracking () {
			if (!this.makerAssetSymbol || !this.makerAssetAddress
				|| !this.takerAssetSymbol || !this.takerAssetAddress) {
				console.log('missing token info')
				return
			}
			this.tokenTrackingRequestLoding = true
			const apiURL = `${this.config.backendAPIURL}/${this.network.id}/token-pair-tracking/add/${this.myAddress}`
			const tokenPair = {
				tokenA: {
					symbol: this.makerAssetSymbol,
					address: this.makerAssetAddress
				},
				tokenB: {
					symbol: this.takerAssetSymbol,
					address: this.takerAssetAddress
				},
			}
			const apiData = {
				tokenpair: tokenPair
			}
			try {
				await this.$http.post(apiURL, apiData)
			} catch (err) {
				console.log(err)
				this.tokenTrackingRequestLoding = false
				return
			}
			await this.loadAccount(true)
			this.tokenTrackingRequestLoding = false
		},

		async deleteTokenPairTracking () {
			if (!this.makerAssetSymbol || !this.makerAssetAddress
				|| !this.takerAssetSymbol || !this.takerAssetAddress) {
				console.log('missing token info')
				return
			}
			this.tokenTrackingRequestLoding = true
			const apiURL = `${this.config.backendAPIURL}/${this.network.id}/token-pair-tracking/delete/${this.myAddress}`
			const apiData = {
				tokenAAddress: this.makerAssetAddress,
				tokenBAddress: this.takerAssetAddress
			}
			try {
				await this.$http.post(apiURL, apiData)
			} catch (err) {
				console.log(err)
				this.tokenTrackingRequestLoding = false
				return
			}
			await this.loadAccount(true)
			this.tokenTrackingRequestLoding = false
		},

		showFillOrderModal (parsedOrder) {
			this.$refs.fillOrderModal.showForm(parsedOrder)
		},

		showNewOrderModal (type) {
			const tokenSelection = {}
			if (type === 'maker-taker') {
				tokenSelection.makerAssetAddress = this.makerAssetInfo.address
				tokenSelection.takerAssetAddress = this.takerAssetInfo.address
			}
			else if (type === 'taker-maker') {
				tokenSelection.makerAssetAddress = this.takerAssetInfo.address
				tokenSelection.takerAssetAddress = this.makerAssetInfo.address
			}
			else {
				console.log('invalid input')
			}
			this.$refs.newOrderModal.showForm(tokenSelection)
		},

		handleFillOrderModalHidden () {
			console.log('handleFillOrderModalHidden')
		},

		handleAddTokenPairWatchListClose () {
			// console.log('handleAddTokenPairWatchListClose')
			this.showAddNewTokenPairWatchForm = false
			// this.$refs.addNewTokenPairWatchCollapse.visible = false
		},

	},
	created () {
		this.init()
	},
	beforeDestroy () {
		// console.log('OrdersByTokenPair beforeDestroy')
		this.turnOffLiveData()
		this.askList = []
		this.bidList = []
		this.askListByRelayer = {}
		this.bidListByRelayer = {}
		this.invalidAskOrderTracking = {}
		this.invalidBidOrderTracking = {}
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.theme--dark .content-box {
	border: none;
}
.price-table-top span {
	/*font-size: 14px;*/
}
.price-table-header {
	background-color: #EDEDED;
	font-size: 15px;
	font-weight: bold;
	color: #565656 !important;
}
.theme--dark .price-table-header {
	background-color: #3f5b4d;
	color: #CCC !important;
}
tr.price-table-header td,
tr.price-table-spread td {
	padding-top: 5px !important;
	padding-bottom: 5px !important;
}
.price-table-spread {
	font-size: 15px;
	font-weight: bold;
	background-color: #ccf0db;
	color: #565656 !important;
	margin-top: 5px !important;
	margin-bottom: 5px !important;
}
.theme--dark .price-table-spread {
	background-color: #3f5b4d;
	color: #CCC !important;
}
.empty-order-cell {
	padding: 40px;
	text-align: center;
}
/*
#popular-trading-pair-select button {
	font-size: 15px;
	line-height: 18px !important;
	padding: 5px 8px !important;
	margin-top: -2px;
}
.mydropdown button {
	font-size: 15px !important;
	line-height: 18px !important;
	padding: 5px 8px !important;
	margin-top: -2px !important;
}
*/
</style>
